import React from "react";
import { Calendar } from "react-multi-date-picker";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import PropTypes from "prop-types";

/**
 * Renders a calendar component with a date picker and an input field.
 *
 * @param {Object} props - The props object.
 * @param {string} props.date - The currently selected date.
 * @param {Function} props.handleDateChange - The function to handle date changes.
 * @param {string} props.inputPlaceHolder - The placeholder text for the input field.
 * @param {number} props.position - Specifying the type of date, i.e., start date or end date.
 * @return {JSX.Element} - The rendered calendar component.
 */
const Calender = ({
  date,
  handleDateChange,
  inputPlaceHolder,
  position,
  isSingleDate,
  maximumDate,
  miniumDate
}) => {
  return (
    <div className="relative flex h-full flex-col ">
      <Calendar
        className="font-MontserratMedium text-ft15-26.25 text-black-000000 "
        renderButton={(direction, handleClick) => (
          <button onClick={handleClick}>
            {direction === "right" ? (
              <div className="flex size-35px items-center justify-center rounded-none border-l border-grey-D9D9D9">
                <IoIosArrowForward />
              </div>
            ) : (
              <div className="flex size-35px items-center justify-center rounded-none border-r border-grey-D9D9D9">
                <IoIosArrowBack />
              </div>
            )}
          </button>
        )}
        value={date}
        onChange={(date) => handleDateChange(date, position)}
        showOtherDays
        maxDate={maximumDate}
        minDate={isSingleDate ? Date.now() : miniumDate}
      />
      <div
        className={`${
          isSingleDate ? "hidden" : ""
        } rounded border border-grey-D9D9D9`}
      >
        <input
          className="w-full rounded py-1 pl-1.5 font-MontserratMedium text-ft15-26.25 text-black-000000 outline-none"
          type="text"
          readOnly
          value={
            date !== null
              ? new Date(date).toLocaleDateString("en-US", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric"
                })
              : ""
          }
          placeholder={inputPlaceHolder}
        />
      </div>
    </div>
  );
};

Calender.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)])
    .isRequired,
  handleDateChange: PropTypes.func.isRequired,
  inputPlaceHolder: PropTypes.string,
  position: PropTypes.string,
  isSingleDate: PropTypes.bool,
  maximumDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date)
  ]),
  miniumDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date)
  ])
};

export default Calender;
